import React from "react";
import { Link } from "react-router-dom";
import api, { API } from "@/lib/api";
import { TurkeyMap } from "@/components/TurkeyMap";
import { Smartphone, MapPin, Fingerprint, Trash2 } from "lucide-react";
import { toast } from "sonner";

export const captureSrc = (c) => (c.photo ? `${API}/field/captures/${c.id}/photo` : null);

export const FieldCaptures = ({ projectId, list, onChange, showMap = true }) => {
  const del = async (id) => { try { await api.delete(`/field/captures/${id}`); toast.success("Capture removed"); onChange?.(); } catch { toast.error("Could not delete"); } };
  return (
    <div className="qs-panel p-4 mt-6" data-testid="field-captures">
      <div className="flex items-center justify-between gap-2">
        <h4 className="font-display font-semibold text-sm flex items-center gap-2"><Smartphone className="h-4 w-4 text-[#00FFFF]" /> Field captures <span className="text-[10px] font-mono text-slate-500">{list?.length ?? "…"}</span></h4>
        <Link to={`/field?project=${projectId}`} className="text-xs text-[#00FFFF] underline" data-testid="open-field-capture">Capture in the field →</Link>
      </div>
      {list && list.length === 0 && <p className="text-xs text-slate-500 mt-2">No geo-tagged captures yet — open the field page on your phone (or the Expo app) to add photos, notes and samples with GPS.</p>}
      {showMap && list && list.length > 0 && <div className="mt-3" data-testid="captures-map"><TurkeyMap captures={list.map((c) => ({ ...c, photo_src: captureSrc(c) }))} height={240} /></div>}
      {list && list.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-3">
          {list.slice(0, 9).map((c) => (
            <div key={c.id} className="bg-[#050A15] border border-white/5 p-2 text-[10px]" data-testid={`capture-${c.id}`}>
              {c.photo ? <img src={captureSrc(c)} alt={c.note || c.kind} className="w-full h-24 object-cover border border-white/5" /> : <div className="w-full h-24 grid place-items-center border border-dashed border-white/10 text-slate-600 uppercase font-mono">{c.kind}</div>}
              <div className="mt-1 text-slate-300 truncate">{c.note || c.kind}</div>
              <div className="font-mono text-slate-500 flex items-center gap-1"><MapPin className="h-3 w-3 text-[#F472B6]" /> {c.lat}, {c.lng}{c.accuracy_m ? ` ±${Math.round(c.accuracy_m)}m` : ""}</div>
              <div className="flex justify-between text-slate-600"><span className="inline-flex items-center gap-1"><Fingerprint className="h-3 w-3" />{c.anchor.slice(0, 10)}</span><button onClick={() => del(c.id)} className="hover:text-[#EF4444]" data-testid={`capture-del-${c.id}`}><Trash2 className="h-3 w-3" /></button></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
